module.exports = __webpack_public_path__ + "6b9e8025d0b64585affe4879146e3135.svg";